import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BrainMapGraph } from '../../pages/corporate/corporate-brain-map/corporate-brain-map.model';

/**
 * Service dédié à tout ce qui concerne les sociétés (controller Company).
 * Liste des contacts d'une société, détail d'un contact.
 * Conception : relation many-to-many via contact_corporate, utilisation des ID.
 */
@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  serverUrl = environment.serverUrl;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) { }

  //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
  get_corporate_for_lender() {
    return this.http.get<[]>(this.serverUrl + 'company/get_corporate_for_lender')
      .pipe(
        catchError(this.handleError)
      );
  }

  //@Cacheable({ cacheBusterObserver: DealsService.cacheBuster$ })
  get_corporate_contact_by_slug_table(slug) {
    return this.http.get<[]>(this.serverUrl + 'company/get_corporate_contact_by_slug_table/' + slug, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  /**
   * Liste des contacts liés à une société (corporate_id).
   */
  get_corporate_contact_by_id(corporate_id: number): Observable<any[]> {
    return this.http
      .get<any[]>(this.serverUrl + 'company/get_corporate_contact_by_id/' + corporate_id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  /**
   * Liste des contacts liés à une société par slug (compatibilité).
   */
  get_corporate_contact_by_slug(corporate_slug: string): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.serverUrl + 'company/get_corporate_contact_by_slug/' + encodeURIComponent(corporate_slug),
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Opportunities where this corporate is linked via associate_corporate_role (with role name).
   */
  get_corporate_by_id(corporate_id: number): Observable<any> {
    return this.http
      .get<any>(this.serverUrl + 'company/get_corporate_by_id/' + corporate_id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  /**
   * May a client space be created for this corporate? Plain company → needs a live
   * deal; management company → needs a lender playing in a live deal (registre).
   * Returns { eligible, is_management_company, reason }.
   */
  get_client_space_eligibility(corporate_id: number): Observable<any> {
    return this.http
      .get<any>(
        this.serverUrl + 'company/get_client_space_eligibility/' + corporate_id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  get_associated_corporate_opportunities_by_id(corporate_id: number): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.serverUrl +
          'company/get_associated_corporate_opportunities_by_id/' +
          corporate_id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * 2D relationship brain map centered on a corporate or contact.
   */
  get_brain_map(
    centerType: 'corporate' | 'contact',
    centerId: number
  ): Observable<BrainMapGraph> {
    return this.http
      .get<BrainMapGraph>(
        `${this.serverUrl}company/get_brain_map/${centerType}/${centerId}`,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Détail d'un contact par son slug (compatibilité).
   */
  get_corporate_contact_details_by_slug(contact_slug: string): Observable<any> {
    return this.http
      .get<any>(
        this.serverUrl + 'company/get_corporate_contact_details_by_slug/' + encodeURIComponent(contact_slug),
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, body was:`, error.error);
    }
    return throwError(() => 'Something bad happened. Please try again later.');
  }

  //@CacheBuster({ cacheBusterNotifier: DealsService.cacheBuster$ })
  searchCorporate(any: any) {
    return this.http.post<any>(this.serverUrl + 'company/searchCorporate', any, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }
}
